class MFooter extends HTMLElement {
  constructor() {
    super();
    this.acc = null;
    this.resizeObserver = null;
    this.init();
  }

  init() {
    this.mobileAccordion = this.querySelector(".m-footer--accordion");
    const mobileStickyBar = document.querySelector(".m-mobile-sticky-bar");

    if (this.mobileAccordion) {
      if (MinimogTheme.config.mqlMobile) {
        this.initMobileAccordion();
      }

      document.addEventListener("matchMobile", () => {
        this.initMobileAccordion();
      });

      document.addEventListener("unmatchMobile", () => {
        this.resetDesktopAccordion();
      });

      window.addEventListener("load", () => {
        this.refreshOpenItems();
      });

      window.addEventListener("resize", () => {
        if (MinimogTheme.config.mqlMobile) {
          this.refreshOpenItems();
        }
      });
    }

    if (mobileStickyBar) {
      const setStickyBarHeight = () => {
        document.documentElement.style.setProperty(
          "--mobile-sticky-bar-height",
          `${mobileStickyBar.offsetHeight}px`
        );
      };

      setStickyBarHeight();

      document.addEventListener("matchMobile", setStickyBarHeight);
      document.addEventListener("unmatchMobile", setStickyBarHeight);
      window.addEventListener("resize", setStickyBarHeight);
    }
  }

  initMobileAccordion() {
    if (!this.mobileAccordion || this.acc) return;

    this.acc = new MinimogLibs.Accordion(this.mobileAccordion, {
      presetContentHeight: true,
      onload: true
    });

    requestAnimationFrame(() => {
      this.refreshOpenItems();
    });

    setTimeout(() => {
      this.refreshOpenItems();
    }, 150);

    setTimeout(() => {
      this.refreshOpenItems();
    }, 500);

    this.observeAccordionContent();
  }

  refreshOpenItems() {
    if (!this.mobileAccordion || !MinimogTheme.config.mqlMobile) return;

    const openItems = this.mobileAccordion.querySelectorAll(
      ".m-accordion--item.open"
    );

    openItems.forEach((item) => {
      const content = item.querySelector(".m-accordion--item-content");

      if (content) {
        content.style.maxHeight = `${content.scrollHeight}px`;
        content.style.opacity = "1";
        content.style.visibility = "visible";
      }
    });
  }

  observeAccordionContent() {
    if (!window.ResizeObserver || this.resizeObserver) return;

    this.resizeObserver = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        const content = entry.target;
        const item = content.closest(".m-accordion--item");

        if (
          item &&
          item.classList.contains("open") &&
          MinimogTheme.config.mqlMobile
        ) {
          content.style.maxHeight = `${content.scrollHeight}px`;
          content.style.opacity = "1";
          content.style.visibility = "visible";
        }
      });
    });

    this.mobileAccordion
      .querySelectorAll(".m-accordion--item-content")
      .forEach((content) => {
        this.resizeObserver.observe(content);
      });
  }

  resetDesktopAccordion() {
    if (!this.mobileAccordion) return;

    this.mobileAccordion
      .querySelectorAll(".m-accordion--item-content")
      .forEach((content) => {
        content.style.removeProperty("max-height");
        content.style.removeProperty("opacity");
        content.style.removeProperty("visibility");
      });
  }
}

if (!customElements.get("m-footer")) {
  customElements.define("m-footer", MFooter);
}